import { combineReducers } from "redux";
import exploreFunds from "./exploreFunds";
import mutualFundsHousesReducer from "./mutualFundsHousesReducers";
import mutualFundsSchemes from "./MutualFundsSchemesReducers";
export default combineReducers({
    exploreFunds: exploreFunds,
    mutualFundsSchemes: mutualFundsSchemes,
    mutualFundsHousesReducer: mutualFundsHousesReducer
});
